export const LANGUAGE_HOMOLOGATION_CODE = {
  ALB: "ALB",
  AND: "AND",
  ARM: "ARM",
  AUT: "AUS",
  AZE: "AZE",
  BEL: "BEL",
  BIH: "BIH",
  BLR: "BLR",
  BGR: "BUL",
  CYP: "CYP",
  CZE: "REP",
  GER: "ALE",
  DEN: "DIN",
  ESP: "ESP",
  EST: "EST",
  FIN: "FIN",
  FRA: "FRA",
  GBR: "GBR",
  GEO: "GEO",
  GRC: "GRE",
  HRV: "CRO",
  HUN: "HUN",
  IRL: "IRL",
  ISL: "ISL",
  ITA: "ITA",
  KAZ: "KAZ",
  LTU: "LTU",
  LUX: "LUX",
  LVA: "LVA",
  MDA: "MDA",
  MKD: "MKD",
  MLT: "MLT",
  MNE: "MNE",
  NED: "PAI",
  NOR: "NOR",
  POL: "POL",
  POR: "POR",
  ROU: "RUM",
  RUS: "RUS",
  SMR: "SMR",
  SRB: "SER",
  SVK: "ESL",
  SVN: "ESL",
  SWE: "SUE",
  TUR: "TUR",
  UKR: "UCR",
  SCO: "ESC",
  ENG: "ING",
};
